// src/features/spotting/pages/ExclusiveGarage.jsx
import React, { useState } from 'react';
import { Search, Sparkles } from 'lucide-react';
import { PinterestGrid } from '../../../components/shared/PinterestGrid';

export const ExclusiveGarage = ({ sightings, loading, showToast, setReportId, setZoomImg }) => {
  // DODANO TĘ LINIĘ PONIŻEJ:
  const [searchQuery, setSearchQuery] = useState('');

  const exclusiveSightings = sightings.filter(s => s.isExclusive && !s.hidden);

  const filtered = exclusiveSightings
    .filter(s => {
      // Zabezpieczenie: jeśli plate lub brand są puste, użyj pustego ciągu
      const plate = s.plate?.toLowerCase() || '';
      const brand = s.brand?.toLowerCase() || '';
      const search = searchQuery.toLowerCase();
      
      return plate.includes(search) || brand.includes(search);
    })
    .sort((a, b) => (b.upvotes || 0) - (a.upvotes || 0));

  if (loading) return <div className="p-12 text-center text-gray-500">Ładowanie...</div>;

  return (
    <div className="max-w-7xl mx-auto p-4 pb-32 lg:pb-4">
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-3">
          <div className="bg-gradient-to-r from-amber-500 to-orange-500 p-3 rounded-xl">
            <Sparkles className="text-white" size={28}/>
          </div>
          <div>
            <h1 className="text-3xl font-black bg-gradient-to-r from-amber-600 to-orange-600 bg-clip-text text-transparent">
              Exclusive Garage
            </h1>
            <p className="text-sm text-gray-600">Kolekcja najrzadszych i najbardziej egzotycznych pojazdów</p>
          </div>
        </div>
      </div>

      <div className="sticky top-0 z-40 bg-white/80 backdrop-blur-xl py-4 mb-6">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
          <input 
            type="text" 
            placeholder="Szukaj w Exclusive Garage..." 
            className="w-full pl-10 pr-4 py-3 bg-gradient-to-r from-amber-50 to-orange-50 text-sm font-medium text-slate-900 rounded-xl border border-amber-200 outline-none focus:ring-2 focus:ring-amber-500 transition-all placeholder:text-gray-400" 
            value={searchQuery} 
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>

      {filtered.length === 0 ? (
        <div className="text-center py-20">
          <Sparkles className="mx-auto mb-4 text-gray-300" size={48}/>
          <p className="text-gray-500 font-semibold">Brak pojazdów w Exclusive Garage</p>
          <p className="text-sm text-gray-400 mt-2">Egzotyczne auta pojawią się tutaj wkrótce</p>
        </div>
      ) : (
        <PinterestGrid 
          sightings={filtered} 
          showToast={showToast} 
          setReportId={setReportId}
          setZoomImg={setZoomImg}
        />
      )}
    </div>
  );
};